<ng-container *ngIf="showHeader">
  <h4>{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
</ng-container>

<payment-contact-info
  [userInfo]="info"
  [countryCode]="countryCode"
  [personType]="personType"
  [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  (onInfoUpdated)="onInfoUpdated($event)"
  (onValidUpdated)="isValid = $event"
></payment-contact-info>

<div class="d-none d-md-block">
  <div class="mt-4 mb-4">
    <ui-newsletter-signup
      class="d-block mb-3"
      *ngIf="!alreadySubscriber"
      [isSubscribe]="info?.subscribedOnNews"
      (onChange)="newsletterUpdate($event)"
    ></ui-newsletter-signup>

  </div>
  <button class="btn btn-pink btn-xl"
          [disabled]="!isValid || loading"
          (click)="submit()">
    {{ 'common.confirm' | translate }}
  </button>

  <terms-and-conditions class="d-block mt-3"
                        (onTermsClick)="onTermsClick.emit()">
  </terms-and-conditions>
</div>

<div class="d-md-none mt-4 pt-3 text-center">
  <button class="btn btn-pink btn-lg confirm-button" [disabled]="!isValid"
          (click)="submit()">
    {{ 'common.confirm' | translate }}
  </button>

  <terms-and-conditions class="d-block mt-3"
                        (onTermsClick)="onTermsClick.emit()">
  </terms-and-conditions>
</div>
